import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "./toast";
import { authedFetch, buildApiUrl } from "./lib/utils";
import { useParams } from "react-router-dom";

export const MessageModal = ({
  freelancer,
  onClose,
  onSent,
  initialMessage = "",
}) => {
  const [message, setMessage] = useState(
    initialMessage ||
      `Hi ${
        freelancer?.name || ""
      }, I'd love to connect about a project.`.trim()
  );
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [confirmation, setConfirmation] = useState(null);
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { id: recipientId } = useParams();

  const handleSend = async () => {
    setError("");
    if (!message.trim()) {
      setError("Please enter a message.");
      return;
    }

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const token = localStorage.getItem("token");
    console.log(recipientId)

    setSending(true);
    let backendError = "";
    try {
      const convRes = await authedFetch(
        buildApiUrl(`/api/v1/messages/conversations`),
        {
          method: "POST",
          body: JSON.stringify({
            participants: [recipientId],
            conversation_type: "direct",
            title: `Chat with ${freelancer?.name || "candidate"}`,
            initial_message: message,
          }),
        }
      );
      console.log(convRes);

      onSent && onSent({ freelancerId: freelancer?.id, message });
      setConfirmation({
        freelancerName: freelancer?.name || "the candidate",
        backendError,
      });

      // Toast and redirect
      if (backendError) {
        addToast({
          type: "warning",
          message: `Message sent locally. ${backendError}`,
        });
      } else {
        addToast({ type: "success", message: "Message sent successfully." });
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900">
            {confirmation
              ? "Message Sent"
              : `Message ${freelancer?.name || "Candidate"}`}
          </h3>
          <button onClick={onClose} className="text-gray-500 hover:text-black">
            ✕
          </button>
        </div>
        {!confirmation ? (
          <>
            {error && (
              <div className="mx-6 mt-4 px-3 py-2 bg-red-50 text-red-700 border border-red-200 rounded-lg text-sm">
                {error}
              </div>
            )}
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm text-gray-700 mb-1">
                  Your Message *
                </label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full h-28 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                />
              </div>
            </div>
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-between items-center">
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                disabled={sending}
                onClick={handleSend}
                className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800 font-semibold disabled:opacity-60"
              >
                {sending ? "Sending…" : "Send"}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="p-6 space-y-4">
              <div className="text-gray-900 font-semibold">
                Your message was sent to {confirmation.freelancerName}.
              </div>
              {confirmation.backendError && (
                <div className="px-3 py-2 bg-yellow-50 text-yellow-800 border border-yellow-200 rounded-lg text-sm">
                  {confirmation.backendError}
                </div>
              )}
            </div>
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end items-center">
              <button
                onClick={onClose}
                className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800 font-semibold"
              >
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default { MessageModal };
